<template>

  <section class="container visible" id="viewcompany">
    
  <div class="backbutton">
    <div class="columns flex  alignLeft">
      <div class="column">
          <a href="#!" class="button" v-on:click="goBack">Zurück</a>
      </div>
    </div>
  </div>
    
    <div class="columns flex alignTop ">
      <div class="column half ">
    
            <div id="companyname" class="columns small-flex spacebetween">
              <div class="column"><strong>{{company}}</strong></div>
              <div class="column right"><router-link v-if="slug" v-bind:to="{ name: 'EditCompany', params: { contact: slug }}" class="icon icon-edit">edit</router-link></div>
            </div>
            
            <div id="companyaddress_box" class="columns small-flex box alignTop">
              <div class="column"><div class="icon icon-location"></div></div>
              <div id="companyaddress" class="column">
                <span class="block">{{companyaddress}}<br>
                {{companyzipcode}} {{companycity}}<br>
                {{companycountry}}
                </span>
              </div>
              
            </div>

            <div class="columns small-flex fewerpadding" v-if="companyphonenumber">
              <div class="column"><div class="icon icon-phone"></div></div>
              <div id="companyphonenumber" class="column">
                <a :href="'tel:'+ formatTel(companyphonenumber)">{{companyphonenumber}}</a>
              </div>
              
            </div>
            
            <div class="columns small-flex fewerpadding" v-if="companyemailaddress">
              <div class="column"><div class="icon icon-send"></div></div>
              <div id="companyemailaddress" class="column">
                <a :href="'mailto:' + companyemailaddress">{{companyemailaddress}}</a>
              </div>
            </div>

            <div class="columns small-flex fewerpadding" v-if="companywebsite">
              <div class="column"><div class="icon icon-website"></div></div>
              <div id="companywebsite" class="column">
                <a :href="companywebsite_link(companywebsite)" target="_blank">{{companywebsite}}</a>
              </div>
            </div>
    
      </div>
      <div class="column half ">
          
          <div id="kontakte" class="columns small-flex">
            <div class="column"><div class="icon icon-contacts2"></div></div>
            <div class="column"><strong>Kontakte</strong></div>
          </div>
          
          
          <div class="staff-list" v-for="(person, i) in staff" :key="i" >           
           
            <div class="columns small-flex box alignTop">
              <div class="column"><div class="icon icon-user"></div></div>
              <div id="personname" class="column grow">
                  <span class="block">{{person.firstname}} {{person.lastname}}
                  <br>{{person.education}} {{person.position}}
                  <br>{{person.department}}
                  </span>
                  <span class="block" v-if="person.phonenumber"><a :href="'tel:' + formatTel(person.phonenumber)">{{person.phonenumber}}</a></span>
                  <span class="block" v-if="person.mobile"><a :href="'tel:' + formatTel(person.mobile)">{{person.mobile}}</a></span>
                  <span class="block" v-if="person.emailaddress"><a :href="'mailto:'+person.emailaddress">{{person.emailaddress}}</a></span>
                
              </div>              
              <div class="column right "><router-link v-bind:to="{ name: 'ViewContact', params: { contact: person.slug }}" class="icon icon-chevron-right">edit</router-link></div>

            </div>
            
         </div>
      </div>      
      
      
      
    </div>
    
    
  </section>
  
</template>
<script>
import firebase from 'firebase'
  
export default {
  name: 'viewcompany',
  data: function(){ 
    return {
      
          edit: false,
      
          company: null,
          companyid: null,
          companyaddress: null,
          companyzipcode: null,
          companycity: null,
          companyemailaddress: null,
          companywebsite: null,
          companyphonenumber: null,
          companyfaxnumber: null,
          companycountry: null,
          slug: null,
          
          staff: []
      
    }
  },
  
/*
  beforeRouteEnter (to, from, next) {
      firebase.firestore().collection('contacts').where('slug', '==', to.params.contact).get().then((querySnapshot) => {
      console.log('beforeRouteEnter');
        querySnapshot.forEach((doc) => {
          next(vm => {
            vm.firstname = doc.data().firstname
            vm.lastname = doc.data().lastname
            vm.emailaddress = doc.data().emailaddress
            vm.phonenumber = doc.data().phonenumber
          })
        })
      })
    },
*/
  
  mounted: function(){
      this.fetchData();
  },
  methods: {
      
    goBack: function(e){
      e.preventDefault();
      this.$router.go(-1)
    },
      
      formatTel: function(tel){
        if(tel && tel !="")
        return tel.replace(/[`~!@#$%^&*()_|\-=?;:'",.<>\{\}\[\]\\\/ ]/gi, '').replace('+490', '+49');
      },
      companywebsite_link: function(companywebsite) {
        if(companywebsite && companywebsite !="")
        return ( companywebsite.toLowerCase().indexOf('http://') > -1 || companywebsite.toLowerCase().indexOf('http://' ) > -1 ? companywebsite : 'http://'+companywebsite)
      },
    
      fetchData : function () {
        console.log('fetching data');
        firebase.firestore().collection('contacts').where('slug', '==', this.$route.params.contact).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            console.log(doc.id, ' => ', doc.data())
            this.firstname = doc.data().firstname

            this.company = doc.data().company
            this.companyid= doc.data().companyid
            this.companyaddress = doc.data().companyaddress
            this.companyzipcode = doc.data().companyzipcode
            this.companycity = doc.data().companycity
            this.companyemailaddress = doc.data().companyemailaddress
            this.companywebsite = doc.data().companywebsite
            this.companyphonenumber = doc.data().companyphonenumber
            this.companyfaxnumber = doc.data().companyfaxnumber
            this.companycountry = doc.data().companycountry
            this.slug = doc.data().slug
          })

          firebase.firestore().collection('contacts').where('companyid', '==', this.slug ).get().then((querySnapshot) => {
                querySnapshot.forEach((doc2) => {
                  console.log(doc2.id, ' => ', doc2.data() )
                  this.staff.push( doc2.data() );
                })})        
                console.log( this.staff )
        })

        
      }
  
    } 
} 
</script>
<style>
  #viewcompany { padding: 5rem 0 0 0; }
  #viewcompany .field { display: flex; padding: 0; }
  #viewcompany .control { padding: 0.43333333em; display: flex; }
  #viewcompany .control-50 { flex: 1 1 50%; width: 50%; max-width: 50%; }
  #viewcompany .control-100 { flex: 0 0 100%; width:100%; max-width: 100%; align-items: stretch; }
  #viewcompany .control input[type=text] { width: 100%; margin: 0; }
  #viewcompany .control input[type=email] { width: 100%; margin: 0; }
  #viewcompany .control input { border-radius: 0 3px 3px 0; }
  #viewcompany .input-icon { display: inline-block; height: 48px; width: 48px; min-width: 48px; border-radius: 3px 0 0 3px; line-height: 48px; }
  #viewcompany .control input { order: 2; }
  #viewcompany .control input-icon { order: 1; }
  #viewcompany .control input:focus + .input-icon { border-color: #00aeff; }

  #viewcompany span.block { display: block; padding: 0.233333em 0}

  #viewcompany .icon-company { background: url(../assets/icons/disc.svg) center center no-repeat; background-size: 1.6333333em;  text-indent: -9999px; }
  #viewcompany .icon-fax { background: url(../assets/icons/print.svg) center center no-repeat; background-size: 1.6333333em;  text-indent: -9999px; }
  #viewcompany .icon-flag { background: url(../assets/icons/flag.svg) center center no-repeat; background-size: 1.6333333em;  text-indent: -9999px; }

  #viewcompany .icon-mobile { background: url(../assets/icons/iphone.svg) center center no-repeat; background-size: 1.6333333em;  text-indent: -9999px; }
  #viewcompany .icon-flag { background: url(../assets/icons/flag.svg) center center no-repeat; background-size: 1.6333333em;  text-indent: -9999px; }

  #viewcompany .icon { display: inline-block; background: #fff; height: 1.6333333em; width: 1.6333333em; min-width: 1.6333333em; border-radius: 0; line-height: 1.6333333em; }
  #viewcompany .icon-location { background: url(../assets/icons/location.svg) center top no-repeat; background-size: 1.8333333em; }
  #viewcompany .icon-phone { background: url(../assets/icons/phone.svg) center center no-repeat; background-size: 1.6333333em; }
  #viewcompany .icon-send { background: url(../assets/icons/envelope-alt.svg) center center no-repeat; background-size: 1.6333333em; }
  #viewcompany .icon-edit { background: url(../assets/icons/edit.svg) center center no-repeat; background-size: 1.6333333em; text-indent: -9999px; }
  #viewcompany .icon-website { background: url(../assets/icons/home-alt.svg) center center no-repeat; background-size: 1.6333333em; }

  #viewcompany .icon-user { background: url(../assets/icons/user.svg) center center no-repeat; background-size: 1.6333333em; }

  #viewcompany .icon-chevron-right { background: url(../assets/icons/chevron-right.svg) center center no-repeat; background-size: 1.933333333em; text-indent: -9999px; }
  #viewcompany .icon-chevron-right:hover { background: url(../assets/icons/chevron-right.svg) center center no-repeat; background-size: 1.93333333em; }


  #viewcompany .control .iconafter#newcompany { display: inline-block; height: 48px; width: 48px; min-width: 48px; border: 0; line-height: 48px; order: 3; text-indent: -9999px; background: url(../assets/icons/add.svg) center center no-repeat; background-size: 1.6333333em; text-indent: -9999px; }


  #viewcompany #viewcompany { height: auto; overflow: hidden; opacity: 0; width: 100%; max-height: 0; transition: max-height 0.5s ease-in-out, opacity 0.5s ease-in-out; cursor: pointer; }
  #viewcompany .visible #viewcompany { max-height: 600px; opacity: 1; }
  #viewcompany .visible .control .iconafter#viewcompany { background: url(../assets/icons/remove.svg) center center no-repeat; background-size: 1.6333333em; }
  
  #viewcompany .column.right { width: 2.13333333em; align-items: flex-start;  }
  
  #viewcompany .fewerpadding .column { padding: 0.22222em 0.9333333em !important; }
  #viewcompany .column.fewerpadding { padding: 0.22222em 0.9333333em !important; }
  #viewcompany .column.grow { flex-grow: 1; }
  #viewcompany .box { padding: 0.93333333em 0 0; }  
  
  #viewcompany #companyname { border-bottom: 1px solid #ddd; }
  #viewcompany #companyname .icon { height: 1.444rem; width: 1.444em; min-width: 1.444em; border-radius: 0; line-height: 1.444rem; }
  #viewcompany #companyname .column { padding: 0.33333rem 0.9333333em }
  #viewcompany #kontakte { border-bottom: 1px solid #ddd; }
  #viewcompany #kontakte .column { padding: 0.33333rem 0.9333333em 0.11em; }
  #viewcompany #kontakte .icon-contacts2 { background: url(../assets/icons/contact-book.svg) center center no-repeat; background-size: 1.2333333em; height: 1.444rem; width: 1.444em; min-width: 1.444em; border-radius: 0; line-height: 1.444rem; padding: 0 !important; }
  
  #viewcompany .box { text-align: left; }
</style>


// WEBPACK FOOTER //
// src/components/ViewCompany.vue